<mat-paginator 
  [length]="totalItems"
  [pageSize]="itemsPerPage"
  [pageSizeOptions]="pageSizeOptions"
  [pageIndex]="currentPage - 1"
  (page)="handlePageEvent($event)"
  aria-label="Select page">
</mat-paginator>
